@if (!isGlobalAdminEnabled) {
    @if (nav.isSubscriptionAndBillingEnabled()) {
        <tapestry-icon-button
            [matMenuTriggerFor]="settingsMenu.matMenu"
            iconName="gear_bold"
            [altText]="TR.key('globalnav.userSettingsMenu-altText')"
            trackingName="adminButton"
        ></tapestry-icon-button>
        <tapestry-dropdown
            #settingsMenu
            [optionsList]="settingsDropDownItems"
            (menuOptionSelected)="menuAction($event)"
        ></tapestry-dropdown>
    } @else {
        <tapestry-icon-button
            iconName="gear_bold"
            altText="TR.key('globalnav.userSettingsMenu-altText')"
            [disabled]="false"
            (iconClicked)="nav.showUserManagementSideNav()"
            trackingName="adminButton"
        ></tapestry-icon-button>
    }
} @else {
    <tapestry-icon-button
        iconName="gear_bold"
        [altText]="TR.key('globalnav.userSettingsMenu-altText')"
        (iconClicked)="goToGlobalAdmin()"
        piTesting="header-global-admin-button"
        trackingName="adminButton"
    ></tapestry-icon-button>
}
